/**
 * Configuration file for environment-specific settings
 */

// Determine the domain based on NODE_ENV
const getDomain = () => {
  return process.env.NODE_ENV === 'production' ? 'pandastack.io' : 'pandastack.in';
};

// Export configuration object
const config = {
  domain: getDomain(),
  // Add other environment-specific configurations here as needed
};

export default config;
